// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant-answer-feedback {
  margin-top: 12px;
  color: #738198;
  font-size: 11px;
}
.assistant-answer-feedback .assistant-feedback-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
}
.assistant-answer-feedback .assistant-feedback-actions button {
  min-height: 36px;
  border: 0;
  padding: 4px 0;
  color: #68778e;
  background: transparent;
  cursor: pointer;
  font: inherit;
}
.assistant-answer-feedback .assistant-feedback-actions button[aria-pressed=true] {
  color: #d92f4e;
  font-weight: 600;
}
.assistant-answer-feedback .assistant-feedback-actions button:focus-visible {
  outline: 2px solid #df3b57;
  outline-offset: 3px;
  border-radius: 3px;
}
.assistant-answer-feedback .assistant-feedback-actions button:disabled {
  opacity: 0.5;
  cursor: wait;
}
.assistant-answer-feedback .assistant-feedback-status {
  display: block;
  font-size: 10px;
}
.assistant-answer-feedback .assistant-feedback-reply {
  margin-top: 6px;
}
.assistant-answer-feedback .assistant-feedback-reply summary {
  cursor: pointer;
  min-height: 36px;
  display: flex;
  align-items: center;
}
.assistant-answer-feedback .assistant-feedback-reply p {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.5;
}

.assistant-feedback-dialog {
  width: min(600px, 100vw - 24px);
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
}
.assistant-feedback-dialog p {
  font-size: 13px;
  line-height: 1.5;
  color: #62718a;
}
.assistant-feedback-dialog form {
  display: grid;
  gap: 14px;
}
.assistant-feedback-dialog label {
  display: grid;
  gap: 6px;
  font-size: 13px;
  color: #34445b;
}
.assistant-feedback-dialog input:not([type=checkbox]), .assistant-feedback-dialog textarea, .assistant-feedback-dialog select {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid #dbe2ec;
  border-radius: 10px;
  background: white;
  color: #26334a;
  font: inherit;
  font-size: 16px;
}
.assistant-feedback-dialog textarea {
  resize: vertical;
}
.assistant-feedback-dialog .assistant-feedback-consent {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.5;
}
.assistant-feedback-dialog .assistant-feedback-consent input {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin: 1px 0;
}
.assistant-feedback-dialog .assistant-feedback-note {
  font-size: 11px;
  margin: 0;
}
.assistant-feedback-dialog .assistant-feedback-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.assistant-feedback-dialog .assistant-feedback-form-actions button {
  min-height: 44px;
  padding: 10px 16px;
  border: 1px solid #dbe2ec;
  border-radius: 10px;
  font: inherit;
  cursor: pointer;
  background: white;
}
.assistant-feedback-dialog .assistant-feedback-form-actions button:last-child {
  background: #df2f4f;
  color: white;
  border-color: #df2f4f;
}
.assistant-feedback-dialog .assistant-feedback-form-actions button:disabled {
  opacity: 0.5;
  cursor: default;
}

.assistant-feedback-error {
  font-size: 12px;
  color: #ae304c;
  line-height: 1.5;
  overflow-wrap: anywhere;
}`, "",{"version":3,"sources":["webpack://./src/pages/ChatsPage/assistantAnswerFeedback.scss"],"names":[],"mappings":"AAAA;EAA6B,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AAI/D;AAJgF;EAA8B,aAAA;EAAe,eAAA;EAAiB,aAAA;AAS9I;AAT6J;EAAS,gBAAA;EAAkB,SAAA;EAAW,cAAA;EAAgB,cAAA;EAAgB,uBAAA;EAAyB,eAAA;EAAiB,aAAA;AAkB7Q;AAlB4R;EAAyB,cAAA;EAAgB,gBAAA;AAsBrU;AAtByV;EAAkB,0BAAA;EAA4B,mBAAA;EAAqB,kBAAA;AA2B5Z;AA3Bkb;EAAa,YAAA;EAAa,YAAA;AA+B5c;AA/Bge;EAA6B,cAAA;EAAgB,eAAA;AAmC7gB;AAnCgiB;EAA4B,eAAA;AAsC5jB;AAtC6kB;EAAU,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;AA4CzoB;AA5CgqB;EAAI,qBAAA;EAAuB,uBAAA;EAAyB,gBAAA;AAiDptB;;AAhDA;EAA6B,+BAAA;EAAuC,+BAAA;EAAiC,gBAAA;AAsDrG;AAtDuH;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AA2D9J;AA3DgL;EAAO,aAAA;EAAe,SAAA;AA+DtM;AA/DmN;EAAQ,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,cAAA;AAqErQ;AArEuR;EAAiD,sBAAA;EAAwB,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,cAAA;EAAgB,aAAA;EAAe,eAAA;AAkFngB;AAlFshB;EAAW,gBAAA;AAqFjiB;AArFqjB;EAA8B,aAAA;EAAe,uBAAA;EAAyB,SAAA;EAAW,gBAAA;AA2FtoB;AA3FwpB;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,aAAA;AAiG3sB;AAjG8tB;EAA2B,eAAA;EAAiB,SAAA;AAqG1wB;AArGuxB;EAAmC,aAAA;EAAe,yBAAA;EAA2B,QAAA;AA0Gp2B;AA1G82B;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,eAAA;EAAiB,iBAAA;AAmH7+B;AAnHggC;EAAe,mBAAA;EAAqB,YAAA;EAAc,qBAAA;AAwHljC;AAxH2kC;EAAa,YAAA;EAAa,eAAA;AA4HrmC;;AA3HA;EAA4B,eAAA;EAAiB,cAAA;EAAgB,gBAAA;EAAkB,uBAAA;AAkI/E","sourcesContent":[".assistant-answer-feedback { margin-top: 12px; color: #738198; font-size: 11px; .assistant-feedback-actions { display: flex; flex-wrap: wrap; gap: 4px 10px; button { min-height: 36px; border: 0; padding: 4px 0; color: #68778e; background: transparent; cursor: pointer; font: inherit; &[aria-pressed=\"true\"] { color: #d92f4e; font-weight: 600; } &:focus-visible { outline: 2px solid #df3b57; outline-offset: 3px; border-radius: 3px; } &:disabled { opacity: .5; cursor: wait; } } } .assistant-feedback-status { display: block; font-size: 10px; } .assistant-feedback-reply { margin-top: 6px; summary { cursor: pointer; min-height: 36px; display: flex; align-items: center; } p { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.5; } } }\n.assistant-feedback-dialog { width: min(600px, calc(100vw - 24px)); max-height: calc(100dvh - 32px); overflow-y: auto; p { font-size: 13px; line-height: 1.5; color: #62718a; } form { display: grid; gap: 14px; } label { display: grid; gap: 6px; font-size: 13px; color: #34445b; } input:not([type=\"checkbox\"]), textarea, select { box-sizing: border-box; width: 100%; min-width: 0; min-height: 44px; padding: 10px 12px; border: 1px solid #dbe2ec; border-radius: 10px; background: white; color: #26334a; font: inherit; font-size: 16px; } textarea { resize: vertical; } .assistant-feedback-consent { display: flex; align-items: flex-start; gap: 10px; line-height: 1.5; input { width: 20px; height: 20px; flex-shrink: 0; margin: 1px 0; } } .assistant-feedback-note { font-size: 11px; margin: 0; } .assistant-feedback-form-actions { display: flex; justify-content: flex-end; gap: 8px; button { min-height: 44px; padding: 10px 16px; border: 1px solid #dbe2ec; border-radius: 10px; font: inherit; cursor: pointer; background: white; &:last-child { background: #df2f4f; color: white; border-color: #df2f4f; } &:disabled { opacity: .5; cursor: default; } } } }\n.assistant-feedback-error { font-size: 12px; color: #ae304c; line-height: 1.5; overflow-wrap: anywhere; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
